import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
    selector: 'app-order-card-timeline-row',
    templateUrl: './order-card-timeline-row.component.html',
    styleUrls: ['./order-card-timeline-row.component.scss'],
    imports: [CommonModule]
})
export class OrderCardTimelineRowComponent {
  public first = input<boolean>(false);
  public number = input<number>();
  public title = input<string>();
  public description = input<string>();
}